import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";
import { RequestQueueItemMetadata } from "@/types/requestQueue";

interface QueueItemMetadataProps {
    metadata: RequestQueueItemMetadata;
}

export const QueueItemMetadata: FC<QueueItemMetadataProps> = ({ metadata }) => {
    const { taskName, marketName, title } = metadata;

    return (
        <>
            {title && <PrimaryText fontWeight="500">{title}</PrimaryText>}

            {taskName && <PrimaryText fontWeight="500">{taskName}</PrimaryText>}

            {marketName && <PrimaryText>{marketName}</PrimaryText>}
        </>
    );
};
